import { useEffect } from 'react';

export const useTurnstile = (containerId, onSuccess) => {
  useEffect(() => {
    const scriptId = 'turnstile-script';

    // Prevent duplicate scripts
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = renderWidget;
      document.body.appendChild(script);
    } else {
      renderWidget(); // If already present, just render the widget again
    }

    function renderWidget() {
      if (window.turnstile && document.getElementById(containerId)) {
        window.turnstile.render(`#${containerId}`, {
          sitekey: '0x4AAAAAAB7lwmF4lXsELWvS',
          theme: 'light',
          action: 'login',
          callback: onSuccess,
        });
      }
    }

    return () => {
      // Cleanup widget on unmount
      const container = document.getElementById(containerId);
      if (container) container.innerHTML = '';
    };
  }, [containerId]);
};
